import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route,
  useParams,
  useLocation,
} from 'react-router-dom';
import { getQueryParam } from 'utils/url';
import { routes } from 'constants/config';
import useFetch from 'components/shared/hooks/useFetch';
import { Spinner } from 'ui';
import ModuleLoadFailure from './ModuleLoadFailure';

const ScormAnalytics = () => {
  const { search } = useLocation();
  const currentGroupId = getQueryParam(search, 'group_id');
  const { lessonId } = useParams();
  const { data, loading, error, runRequest } = useFetch(
    routes.LESSON_OVERVIEW.SCORM_ANALYTICS(lessonId, currentGroupId),
  );
  if (loading) return <Spinner />;
  if (error) {
    return <ModuleLoadFailure reload={runRequest} />;
  }
  const { averageScore, averageTimeTracked } = data;

  return (
    <section className="Module Module--bordered">
      <table className="OverviewTable">
        <tbody>
          {averageScore && (
            <tr>
              <td>
                <span>
                  {t('lessons.scorm.average_score')} {averageScore}%
                </span>
              </td>
            </tr>
          )}
          <tr>
            <td>
              <span>
                {t('lessons.scorm.average_time')} {averageTimeTracked}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};

const ScormAnalyticsRoot = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/lessons/:lessonId" component={ScormAnalytics} />
      </Switch>
    </BrowserRouter>
  );
};

export default props => <ScormAnalyticsRoot {...props} />;
